<script>
    import BaseDialog from './BaseDialog.svelte';

    let {
        dialogRef = $bindable(),
        settingsArray = [],
        settingsHash = {},
        onKeydown = null
    } = $props();

    function focus(x) { x.focus(); }
</script>

<BaseDialog bind:dialogRef={dialogRef} size="sm:max-w-4xl" {onKeydown}>
    {#snippet children({ dialog })}
        <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div use:focus class="grid grid-cols-2 gap-4 p-4" tabindex="0" onkeydown={onKeydown}>
            {#each settingsArray as item}
                <div class="flex">
                    <div class="w-4 font-sans font-semibold uppercase text-gray-300">{item[1]}</div>
                    <div class="{settingsHash[item[0]] ? 'bg-green-100': ''}">{item[0]}</div>
                </div>
            {/each}
        </div>
    {/snippet}
</BaseDialog>
